import axios from "axios";

const AuthService = axios.create({
  baseURL: `${process.env.REACT_APP_API}/cobra/auth`,
});

const AuthServices = {
  login: (data: { username: string; password: string }) =>
    AuthService.post("/login", data),
};

export default AuthServices;
